import { useIncognito } from '#pplx/frontend/apps/ask/incognito/useIncognito.js';
import { useIsIncognito } from '#pplx/frontend/apps/ask/incognito/useIsIncognito.js';
import { useRegisterShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { useSidebarToggleActions } from '#pplx/frontend/apps/ask/layout/sidebar/host/useSidebarToggleActions.js';
import { useCallback } from 'react';
export function useSidebarShortcuts() {
    const { toggleSidebar } = useSidebarToggleActions();
    const { toggleIncognito } = useIncognito();
    const { isIncognito, isAlwaysIncognitoRequired } = useIsIncognito({
        reason: 'sidebar-shortcuts',
    });
    const handleToggleIncognito = useCallback((event) => {
        event.preventDefault();
        if (!isAlwaysIncognitoRequired)
            toggleIncognito(isIncognito);
    }, [isAlwaysIncognitoRequired, isIncognito, toggleIncognito]);
    const handleToggleSidebar = useCallback((event) => {
        event.preventDefault();
        toggleSidebar();
    }, [toggleSidebar]);
    useRegisterShortcut({ id: 'toggle-incognito', handler: handleToggleIncognito });
    useRegisterShortcut({ id: 'toggle-sidebar', handler: handleToggleSidebar });
}
//# sourceMappingURL=useSidebarShortcuts.js.map